import { TIME_UNITS } from '../../../scheduler/schedulerConstants';
import { AutocompleteOption } from '../../form/widgets/OptionRendererProps';
import { ScheduleFormWidgetValue, SupportedSchedulerDurationUnit } from './types';

export const DEFAULT_DURATION_UNIT = TIME_UNITS.day;
export const DEFAULT_DURATION_UNIT_LABEL = 'Days';

export const DEFAULT_SCHEDULE_TIME_VALUE = '000000';

export const DEFAULT_SCHEDULE_FORM_WIDGET_VALUE: ScheduleFormWidgetValue = {
    durationSpecified: false,
    startDate: '',
    endDate: '',
    duration: {
        unit: DEFAULT_DURATION_UNIT
    }
};

export const DEFAULT_DURATION_UNIT_OPTIONS: AutocompleteOption[] = [
    {
        id: DEFAULT_DURATION_UNIT,
        label: DEFAULT_DURATION_UNIT_LABEL
    }
];

export const DURATION_UNITS_DATA_IDENTIFIER = 'Time';
export const DURATION_UNITS_DATA_FORCE_FETCH_ON_MOUNT = true;
export const DURATION_UNITS_DATA_PAGE_SIZE = 10;

export const CALENDAR_DATA_PAGE_SIZE = 10;

export const SCHEDULE_CALCULATION_DEBOUNCE_MS = 500;

export const SUPPORTED_SCHEDULER_DURATION_UNITS: SupportedSchedulerDurationUnit[] = Object.values(TIME_UNITS);

export const SUPPORTED_SCHEDULER_TIME_DURATION_UNITS: SupportedSchedulerDurationUnit[] = [
    TIME_UNITS.minute,
    TIME_UNITS.hour
] as const;

export const SCHEDULE_FORM_WIDGET_FIELD_NAMES = {
    DURATION_SPECIFIED: 'durationSpecified',
    ITEM_NAME: 'name',
    START_DATE: 'startDate',
    START_TIME: 'startTime',
    END_DATE: 'endDate',
    END_TIME: 'endTime',
    DURATION_UNIT: 'duration.unit',
    DURATION_VALUE: 'duration.value',
    CALENDAR: 'calendar',
    LOCATION: 'location'
} as const;
